// src/components/ThemeLightbox.js
import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import styles from './ThemeLightbox.module.css';

const ThemeLightbox = ({ theme, onApply, onCancel, clickPosition }) => {
  const contentRef = useRef(null);
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!overlayRef.current || !contentRef.current) return;

    // On mobile devices
    if (window.innerWidth <= 768) {
      if (clickPosition) {
        // Calculate position relative to the document
        const yPosition = clickPosition.y + window.scrollY;
        
        // Scroll to the clicked position
        window.scrollTo({
          top: Math.max(0, yPosition - 100),
          behavior: 'smooth'
        });
      } else {
        // Fallback if no click position: place near top of current scroll
        window.scrollTo({
          top: window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }, [clickPosition]);

  if (!theme) return null;
  
  return (
    <div className={styles.lightboxOverlay} ref={overlayRef}>
      <div className={styles.lightboxContent} ref={contentRef}>
        <button className={styles.closeButton} onClick={onCancel}>
          <X size={24} />
        </button>
        
        <div className={styles.previewContainer}>
          <div className={styles.previewImageWrapper}>
            <img 
              src={theme.preview} 
              alt={`${theme.name} theme preview`} 
              className={styles.previewImage}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
            <div className={styles.previewPlaceholder} style={{ display: 'none' }}>
              <span>{theme.name} Preview</span>
            </div>
          </div>
          
          <div className={styles.themeInfo}>
            <h2 className={styles.themeName}>{theme.name}</h2>
            <p className={styles.themeDescription}>{theme.description}</p>
          </div>
        </div>
        
        <div className={styles.actionButtons}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.applyButton} onClick={onApply}>
            Apply Theme
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThemeLightbox;